export default __webpack_public_path__ + "static/Rhyme5-f9380ee8bf46d9d78825fa184c882c8a.mp3";